import angular from 'angular';
import './modals.scss';

/* @ngInject */
export default class ModalService {
    constructor($uibModal, $window, $document, HPConfig) {
        this.$document = $document;
        this.$window = $window;
        this.HPConfig = HPConfig;
        this.$uibModal = $uibModal;
        this.lgModal = null;
        this.filterModal = null;
        this.scrollX = null;
        this.scrollY = null;
    }

    getLgModal() {
        return this.lgModal;
    }

    launchLgModal(params) {
        this.lgModal = this.$uibModal.open({
            templateUrl: params.templateUrl,
            windowClass: params.windowClass,
            controller: params.controller,
            controllerAs: params.controllerAs,
            size: params.size || 'lg',
            keyboard: true,
            animation: false,
            resolve: params.resolve,
        });

        // Once the modal has been rendered, set the body of the page to position: fixed
        // and store the x and y scroll values
        this.lgModal.rendered.then(() => {
            if (this.$window.innerWidth < this.HPConfig.screenSizes.screen_md) {
                this.scrollX = this.$window.pageXOffset;
                this.scrollY = this.$window.pageYOffset;
                angular.element(this.$document[0].body).addClass('fixed-body');
            }
        });

        // Before the modal is closed, set the body of the page to position: static
        // and scroll the page back to the x and y scroll values before the modal was opened
        this.lgModal.result.then(() => {
            if (this.$window.innerWidth < this.HPConfig.screenSizes.screen_md) {
                angular.element(this.$document[0].body).removeClass('fixed-body');
                this.$window.scroll(this.scrollX, this.scrollY);
            }
        });

        return this.lgModal;
    }

    closeLgModal() {
        if (this.lgModal) {
            this.lgModal.close();
            this.lgModal = null;
        }
    }

    getPipelineFilterModal() {
        return this.filterModal;
    }

    launchPipelineFilterModal(params) {
        this.filterModal = this.$uibModal.open({
            templateUrl: params.templateUrl,
            windowClass: params.windowClass,
            controller: params.controller,
            controllerAs: params.controllerAs,
            size: 'lg',
            keyboard: true,
            animation: false,
        });
    }
}


// function modalService($uibModal, $window, $document, HPConfig) {
//  var lgModal, filterModal, scrollX, scrollY;

//  return {
//      launchPipelineFilterModal: launchPipelineFilterModal,
//      getPipelineFilterModal: getPipelineFilterModal,
//      launchLgModal: launchLgModal,
//      getLgModal: getLgModal,
//      closeLgModal: closeLgModal
//  };

//  function getLgModal() {
//      return lgModal;
//  }

//  function launchLgModal(params) {
//      lgModal = $uibModal.open({
//          templateUrl: params.templateUrl,
//          windowClass: params.windowClass,
//          controller: params.controller,
//          controllerAs: params.controllerAs,
//          size: params.size || "lg",
//          keyboard: true,
//          animation: false,
//          resolve: params.resolve
//      });

//      // Once the modal has been rendered, set the body of the page to position: fixed
//      // and store the x and y scroll values
//      lgModal.rendered.then(function() {
//          if ($window.innerWidth < HPConfig.screenSizes.screen_md) {
//              scrollX = $window.pageXOffset;
//              scrollY = $window.pageYOffset;
//              angular.element($document[0].body).addClass("fixed-body");
//          }
//      });

//      // Before the modal is closed, set the body of the page to position: static
//      // and scroll the page back to the x and y scroll values before the modal was opened
//      lgModal.result.then(function() {
//          if ($window.innerWidth < HPConfig.screenSizes.screen_md) {
//                 angular.element($document[0].body).removeClass("fixed-body");
//                 $window.scroll(scrollX, scrollY);
//             }
//      });

//      return lgModal;
//  }

//  function closeLgModal() {
//      lgModal.close();
//      lgModal = null;
//  }

//  function getPipelineFilterModal() {
//      return filterModal;
//  }

//  function launchPipelineFilterModal(params) {
//      filterModal = $uibModal.open({
//          templateUrl: params.templateUrl,
//          windowClass: params.windowClass,
//          controller: params.controller,
//          controllerAs: params.controllerAs,
//          size: "lg",
//          keyboard: true,
//          animation: false
//      });
//  }
// }



// WEBPACK FOOTER //
// ./src/app/modals/modalService.js